export const METHOD = {
  HTTP: {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
  },
};

export const REFRESH_TOKEN_TIME = 1500000;
//TODO should be less (1 minute?)
export const REFRESH_TRIGGER_SECONDS = 240;

export const TOKEN_KEY = "token";
export const S_TOKEN_USER = "tokenUser";
export const S_KYC = "kyc";
export const S_MSISDN = "msisdn";
export const S_EMAIL = "email";
export const S_SSO = "sso";
export const S_INSTNT_TXN_ID = "instntTxnId";
export const S_INSTNT_TXN_ID_QR = "instntTxnIdQr";
export const S_INSTNT_FINGER_PRINT = "fingerprint";
export const S_INSTNT_TOKEN = "instntToken";
export const S_PERSONAL = "personal";
export const S_BANKING_TYPE = "bankingType";
export const S_BANKING_TYPE_SWITCH = "bankingTypeSwitch";
export const S_SMART_VERIFY_BRAND = "smartBrand";
export const S_SMART_VERIFY_LANGUAGE = "smartLanguage";
export const TIMEOUT = "timeout";
export const EXPIRES_AT = "expiresAt";
export const REFRESH_EXPIRES_AT = "refreshExpiresAt";
export const PERSIST_KEY = "persist:root";
export const PRODUCTION_ENV = "production";
export const REFRESH_TIMER_ID = "timerID";
export const S_APPLICANT_ID = "applicantID";
export const S_APPLICANT_MEMBER_NO = "memberNumber";
export const S_APPLICANT_CIF_ID = "cifId";
export const S_ACCOUNT_ID = "accountId";
export const S_STAFF_ID = "staffId";
export const S_STAFF_EMAIL = "staffEmail";
export const S_STAFF_MSISDN = "staffMsisdn";
export const S_CURRENT_MEMBER_ID = "memberIdInProgress";
export const S_CURRENT_MEMBER_NAME = "memberNameInProgress";
export const S_CURRENT_BRANCH_ACTIVE_MENU = "branchActiveMenu";
export const S_MEMBER_INFO_WELCOME_SHOWN = "welcomeShown";
export const S_CURRENT_MEMBER_IN_MARKETPLACE = "memberInMarketPlace";
export const EXISTING_OR_SAME_PRODUCT_MESSAGE =
  "getExistingOrSameProductMessage";
export const IS_LOGOUT = "isLogout";
export const S_QR_KYC = "qrKycProcess";
export const S_MEMBER_VAULT_UPDATE = "refreshMemberVault";
export const TERMDEPOSITEPRODUCT = "termdepositproduct";
export const REGISTERCONTRACTPRODUCT = "RegisterContractProduct";
export const VAULT_PASSWORD = "vault-password";
export const VERIFICATION_CODE = "/verification-code";
export const IS_SET_PASSWORD_VISIT = "isSetPasswordVisit";
export const SORT_ON_PRIORITY = "priority";
export const LENDING_PRODUCT = "lendingproduct";
export const DEBIT_CARD_ONLINE_BANKING = "debitCard";
export const QUESTIONNAIRE_PRODUCT_ID = "questionnaireProductId";
export const DEFAULT_BRAND = "CoS";
export const DEFAULT_LANGUAGE = "en";
export const APP_SMARTOPEN = "SMARTOPEN";
export const APP_SMARTVERIFY = "SMARTVERIFY";
export const APP_SMARTBRANCH = "SMARTBRANCH";

export const HTTP_STATUS = {
  OK: 200,
  ACCEPTED: 202,
  BAD_REQUEST: 400,
  UNAUTHORISED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  REQUEST_ENTITY_TOO_LARGE: 413,
  UNPROCESSABLE_ENTITY: 422,
  INTERNAL_SERVER_ERROR: 500,
};

export const ERROR_CODE = {
  PERMISSION_DENIED: "100000",
  FAIL_CREATE_TOKEN: "100001",
  INVALID_PASSWORD: "100002",
  ACCOUNT_EXIST: "100003",
  CREDENTIAL_CONFLICT: "100004",
  ACCOUNT_NOT_EXIST: "100005",
  ACCOUNT_CREATE_FAIL: "100006",
  ACCOUNT_MODIFY_FAIL: "100007",
  ACCOUNT_DEL_FAIL: "100008",
  PASSWORD_CRITERIA_FAIL: "100009",
  ACCOUNT_SET_PASSWORD_FAIL: "100010",
  REFRESH_EXPIRED: "100011",
  VAULT_JSON_EXCEED_LIMIT: "100012",
  VAULT_JSON_INVALID: "100013",
  VAULT_EXCEED_LIMIT: "100014",
  USER_INACTIVE: "100015",
  USER_LOGOUT: "100016",
  ACCOUNT_LOCKED: "100017",
  USER_DUPLICATE_LOGIN: "100018",
  TOO_EARLY_REFRESH: "100019",
  OTP_FAIL_TO_SAVE: "100101",
  OTP_EXPIRES: "100102",
  OTP_INVALID: "100103",
  OTP_WRONG_PURPOSE: "100104",
  OTP_EXCEED_LIMIT: "100105",
  VALIDATION_ERROR: "44003",
  ACCESS_DENIED: "44404",
  EXISTING_MEMBER: "103004",
  FAIL_ASSERTION: "102001",
  DATA_NOT_AVAILABLE: "102006",
  INSTNT_FORM_ERROR: "102007",
  NO_ACTIVITY: "100020",
  DOCS_STILL_CREATING: "103023",
  PARTIAL_MATCH: "103018",
  APPLICATION_IN_REVIEW: "103025",
  MOBILE_NOT_EXIST: "100026",
  SSO_ACCOUNT_DIFFERS: "100028",
  SSO_ACCOUNT_DIFFERS_C1_MISSING: "100029",
  DUPLICATE_CREDENTIAL: "100030",
  JOINT_APPLICANT_CONFLICT: "103043",
  SSO_ACCOUNT_INFO_NOT_AVAILABLE: "100034",
  APPLICANT_EMAIL_PHONE_NOT_FOUND: "103046",
};

export const USER_ROLE = {
  STAFF: "staff",
  MEMBER: "member",
};
